/**
 * OCPP session outcome bucket (ADR-0029). Distinct from UI {@link ChargeOutcome}
 * in `session.labels.ts` (`in_progress` | `completed`).
 */
export const SessionQualification = {
  SUCCESSFUL: 'SUCCESSFUL',
  FAILED: 'FAILED',
  ABORTED: 'ABORTED',
  NOT_CLOSED: 'NOT_CLOSED',
  REFUSED_AT_START: 'REFUSED_AT_START',
  IN_PROGRESS: 'IN_PROGRESS',
} as const;

export type SessionQualification =
  (typeof SessionQualification)[keyof typeof SessionQualification];
